import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders } from '../../../../../Containers/Config/index.js';
import { CREATE_EXPENDITURE_RULE, CREATE_EXPENDITURE_RULE_SUCCESS, CREATE_EXPENDITURE_RULE_ERROR } from '../../../actionType';
import apiCall from '../../../apiCall';
import cogoToast from 'cogo-toast';
import { Constant } from '../../../../../Containers/Helpers/constant.js';

function* createExpenditureRule({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${baseUrl}/admin/rules`,
      method: 'POST',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      data: payload.data,
    });

    if (response.status === 200) {
      cogoToast.success(`Expenditure Rule created successfully`);
      yield put({
        type: CREATE_EXPENDITURE_RULE_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`Something went wrong!`);
      yield put({
        type: CREATE_EXPENDITURE_RULE_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: CREATE_EXPENDITURE_RULE_ERROR, payload: error });
  }
}

export function* watchCreateExpenditureRule() {
  yield takeEvery(CREATE_EXPENDITURE_RULE, createExpenditureRule);
}

function* createExpenditureRuleSaga() {
  yield all([fork(watchCreateExpenditureRule)]);
}

export default createExpenditureRuleSaga;
